<template>
    <div>
        <div class="row">
      <span class="font-weight-bold">
        Éves km futás
      </span>
            <span class="font-weight-light">
        (ezer km)
      </span>
        </div>
        <div class="row mb-2">
            <div
                v-for="each of annualMileages"
                :key="'annual_mileage' + each"
                class="col"
            >
                <button
                    type="button"
                    :class="{'btn-light': each !== annualMileage, 'btn-primary': each === annualMileage }"
                    class="btn btn-square btn-sm btn-block"
                    @click="setAnnualMileage(each)"
                >
                    {{ each }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
  import Vue from 'vue';
  import { Component } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  const priceSearchModule = namespace('price_search');

  @Component
  export default class PriceSearchAnnualMileagesSelector extends Vue {
    @priceSearchModule.Getter('getAnnualMileages') annualMileages;
    @priceSearchModule.Getter('getAnnualMileage') annualMileage;
    @priceSearchModule.Mutation('setAnnualMileage') setAnnualMileage;
  }
</script>
